<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    //
  }),
  mounted() {
    // creates and insert the KARTE initialization script
    const initScript = document.createElement('script')
    initScript.textContent = `!function(n){
      if(!window[n]){
        var o=window[n]=function(){
          var n=[].slice.call(arguments);
          return o.x?o.x.apply(0,n):o.q.push(n);
        };
        o.q=[],o.i=Date.now(),
        o.allow=function(){o.o="allow"},
        o.deny=function(){o.o="deny"};
      }
    }("krt");`
    document.head.appendChild(initScript)

    // insert the script data to <head> (should not appear in page source when inspected)
    const scriptUrl = process.env.VUE_APP_KARTE_URL
    if (scriptUrl) {
      const externalScript = document.createElement('script')
      externalScript.async = true
      externalScript.src = scriptUrl
      document.head.appendChild(externalScript)
    } else {
      console.error('VUE_APP_KARTE_URL is not defined')
    }
  },
}
</script>
